import { render } from "./langSelector.vue?vue&type=template&id=c6a2db68"
import script from "./langSelector.vue?vue&type=script&lang=js"
export * from "./langSelector.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__